import React, { Component } from 'react';
import { array, number, func, string, object } from 'prop-types';
import classnames from 'classnames';
import Button from 'ps-components/Button/Button';
import ListPanel from 'ps-components/ListPanel/ListPanel';
import './JobPricingSummaryList.scss';

class JobPricingSummaryList extends Component {
  constructor(props) {
    super(props);

    this.formatCurrency = (record, value) => {
      // This is a fix for currencies that do not map properly e.g: "EUR (GER)"
      const trimmedCurrency = record.currency.includes('EUR') ? 'EUR' : record.currency;
      if (value) {
        return value.toLocaleString(undefined, {
          style: 'currency',
          currency: trimmedCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      }

      return 'Salary unavailable at this time.';
    };
  }

  static propTypes = {
    data: array,
    notes: string,
    selectedTab: string,
    addCompSummaryID: func,
    selectedJobIDs: array,
    clearSelectedJobs: func,
    history: object,
    benchmarkYear: number,
    setSelectedBenchmarkYear: func
  };

  getColumns(isPricedJobs) {
    if (isPricedJobs) {
      return [
        {
          dataKey: 'title',
          field_type_code: 'text',
          title: 'Company Jobs'
        },
        {
          dataKey: 'base50th',
          field_type_code: 'currency',
          title: 'Base Pay at 50th'
        },
        {
          dataKey: 'code',
          field_type_code: 'text',
          title: 'Job Code'
        },
        {
          dataKey: 'codeKey',
          field_type_code: 'text',
          title: 'Job Code Key'
        }
      ];
    }

    return [
      {
        dataKey: 'title',
        field_type_code: 'text',
        title: 'Company Jobs'
      },
      {
        dataKey: 'reason',
        field_type_code: 'text',
        title: 'Reason'
      },
      {
        dataKey: 'code',
        field_type_code: 'text',
        title: 'Job Code'
      },
      {
        dataKey: 'codeKey',
        field_type_code: 'text',
        title: 'Job Code Key'
      }
    ];
  }

  addBasePayToJob(data) {
    return data.map(row => {
      row.job.base50th = row.base50th;
      return row.job;
    });
  }

  addReasonToJob(data) {
    return data.map(row => {
      row.job.reason = row.reason;
      return row.job;
    });
  }

  openCompSumModal = () => {
    const { history, selectedJobs } = this.props;
    const { setSelectedBenchmarkYear, benchmarkYear } = this.props;
    setSelectedBenchmarkYear(benchmarkYear);

    history.push(`/market-analysis/rules-based-pricing/jobs/${selectedJobs[0].id}/compensation-summary-report`, {
      modal: true,
      modalType: 'COMPENSATION_SUMMARY_REPORT',
      modalProps: { className: 'comp-sum__modal', orgJob: selectedJobs[0] },
      component: 'COMPENSATION_SUMMARY_REPORT'
    });
  };

  render() {
    const { data, notes, selectedTab, addCompSummaryID, selectedJobs, clearSelectedJobs } = this.props;
    const hasSelectedJobs = selectedJobs.length === 0;
    if (data.length === 0) {
      return (
        <div className="results-list">
          <div className="results-list__notes results-list__no-jobs">{notes}</div>
        </div>
      );
    }

    const isPricedJobs = selectedTab === 'priced';
    const listPanelClassname = isPricedJobs
      ? 'results-list__items results-list__priced-jobs'
      : 'results-list__items results-list__not-priced-jobs';
    const columns = this.getColumns(isPricedJobs);
    let transformedData = isPricedJobs ? this.addBasePayToJob(data, isPricedJobs) : this.addReasonToJob(data);
    const formatter = { currency: this.formatCurrency };
    const buttonClass = classnames({
      'pxl-btn pxl-btn-primary pxl-btn-sm': true,
      disabled: hasSelectedJobs
    });
    return (
      <div className="results-list">
        <div className="results-list__header">
          <div className="results-list__header-notes">{notes}</div>
          <div className="result-list__header-actions">
            <div className="pxl-text-small result-list__header-count">
              {`${selectedJobs.length} selected`}
              <i className="icon-cancel result-list__header-count-clear" onClick={clearSelectedJobs} />
            </div>
            <Button className={buttonClass} onClick={this.openCompSumModal} disabled={hasSelectedJobs}>
              Generate Summary
            </Button>
          </div>
        </div>
        <ListPanel
          items={transformedData}
          columns={columns}
          expandedMaxColumnCount={2}
          hideCheckBox={false}
          hideTableHeader={false}
          idProp="id"
          className={listPanelClassname}
          fieldTypeValueFormatters={formatter}
          rowCheckBoxClick={addCompSummaryID}
          selectedListRows={selectedJobs.map(job => job.id)}
        />
      </div>
    );
  }
}

export default JobPricingSummaryList;
